import { Component, Input } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { OnInit } from "@angular/core";

@Component({
  selector: "termo-moeda-error",
  templateUrl: "./termo-moeda-error.component.html",
  styleUrls: ["./termo-moeda-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class TermoMoedaErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ColumnsCurrencyTerm: string[] = [
    "entryTypeId",
    "portfolioDocument",
    "portfolioName",
    "bank",
    "branch",
    "account",
    "portfolioClearingAccount",
    "operationTypeId",
    "cetipSettlement",
    "baseValue",
    "contractNumber",
    "futureFee",
    "quoteExpirationTypeId",
    "currencyId",
    "crossRate",
    "expirationDate",
    "financialValue",
    "interestFee",
    "isNewCounterpart",
    "counterpartName",
    "counterpartDocument",
    "counterpartClearingAccount",
    "annotations",
  ];

  ngOnInit(): void {}
}
